import { BladeDamagesRepository } from "@/api/Repositories";
import { UsedMaterialsRepository } from "@/api/Repositories";

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    list (state, data) {
      state.list = []
      state.list = data
    },
  },
  actions: {
    list ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        BladeDamagesRepository.get(obj)
          .then(response => {
            const data = response.data.data.used_material
            for (let i = 0; i < data.length; i++) {
              const element = data[i]
              element.option = element.material_type_id
            }
            commit('list', data)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    create (context, data) {
      return new Promise((resolve, reject) => {
        UsedMaterialsRepository.create(data)
          .then((response) => {
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    edit (context, data) {
      return new Promise((resolve, reject) => {
        UsedMaterialsRepository.update(data)
          .then(() => {
            resolve();
          }).catch(errorEdit => {
            reject(errorEdit);
          });
      });
    },
    delete (context, id) {
      return new Promise((resolve, reject) => {
        UsedMaterialsRepository.delete(id)
          .then(() => {
            resolve();
          })
          .catch(errorDelete => {
            reject(errorDelete);
          });
      });
    }
  }
}
